/**
 * Meta (Facebook) Pixel helpers.
 * Base pixel is injected in app.blade.php when metaPixelId is configured.
 * Pass the same eventID used by CAPI for deduplication.
 */

export function isMetaPixelReady() {
    return typeof window !== "undefined" && typeof window.fbq === "function";
}

/**
 * Track a standard or custom Meta Pixel event.
 * @param {string} eventName e.g. 'PageView', 'Lead', 'CompleteRegistration'
 * @param {Record<string, unknown>} [params]
 * @param {{ eventID?: string }} [options]
 */
export function trackMetaEvent(eventName, params = {}, options = {}) {
    if (!isMetaPixelReady() || !eventName) {
        return;
    }

    try {
        const eventOptions =
            options?.eventID != null && options.eventID !== ""
                ? { eventID: String(options.eventID) }
                : undefined;

        if (eventOptions) {
            window.fbq("track", eventName, params || {}, eventOptions);
        } else if (params && Object.keys(params).length > 0) {
            window.fbq("track", eventName, params);
        } else {
            window.fbq("track", eventName);
        }
    } catch (error) {
        console.warn("[Meta Pixel] Failed to track event:", eventName, error);
    }
}

/**
 * Track a PageView for Inertia SPA navigations (initial load is handled by the base pixel).
 */
export function trackMetaPageView() {
    trackMetaEvent("PageView");
}

/**
 * Fire a conversion from Inertia flash (string name or { name, event_id }).
 * @param {string|{name?: string, event_id?: string}|null|undefined} flashEvent
 */
export function trackMetaFlashEvent(flashEvent) {
    if (!flashEvent) {
        return;
    }

    if (typeof flashEvent === "string") {
        trackMetaEvent(flashEvent);
        return;
    }

    if (typeof flashEvent === "object" && flashEvent.name) {
        trackMetaEvent(flashEvent.name, {}, { eventID: flashEvent.event_id });
    }
}
